// extracted by mini-css-extract-plugin
export default {"container":"AttachmentsOrderForm_container__wJOZO","buttonAddFile":"AttachmentsOrderForm_buttonAddFile__02Vzh"};